import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function Creador() {
  return <section id="creador" className="py-[100px] bg-[radial-gradient(ellipse_60%_50%_at_30%_50%,rgba(224,122,80,0.12)_0%,transparent_60%),linear-gradient(180deg,#120806_0%,#1a0f08_100%)]" data-id="element-137">
      <div className="container-custom" data-id="element-138">
        <div className="text-center mb-12" data-id="element-139">
          <p className="text-[11px] tracking-[3px] uppercase text-gold mb-3" data-id="element-140">
            Sobre el creador
          </p>
          <div className="w-[60px] h-[2px] bg-gradient-to-r from-gold to-gold-light mx-auto" data-id="element-141" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-[60px] items-center max-w-[860px] mx-auto text-center md:text-left" data-id="element-142">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="relative shrink-0 mx-auto md:mx-0" data-id="element-143">
            <div className="w-[200px] h-[200px] rounded-[12px] border-2 border-gold/30 overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.4)]" data-id="element-144">
              <img src="https://i.postimg.cc/FRmCJJBj/escritor.webp" alt="Hugo Pagano" className="w-full h-full object-cover" loading="lazy" data-id="element-145" />
            </div>
            <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-gradient-to-br from-gold to-gold-light text-deep text-[11px] font-bold tracking-[1px] px-3.5 py-1.5 rounded-full whitespace-nowrap" data-id="element-146">
              Hugo Pagano
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-147">
            <h2 className="font-display text-[32px] font-black text-white mb-4 leading-[1.2]" data-id="element-148">
              Hugo Pagano
            </h2>
            <p className="text-[15px] text-gray leading-[1.8] mb-6" data-id="element-149">
              Durante años vi cómo personas con reflujo crónico pasaban de
              médico en médico, de antiácido en antiácido, sin entender
              realmente qué estaba pasando en su cuerpo. La información existe,
              pero nadie la traduce en pasos concretos y aplicables.
              <br data-id="element-150" />
              <br data-id="element-151" />
              El{' '}
              <strong className="text-gold-light" data-id="element-152">
                Protocolo de Reprogramación Digestiva™
              </strong>{' '}
              nació de investigación, de trabajo con personas reales y de la
              convicción de que el control sobre tu digestión no requiere años
              de tratamiento. Requiere la información correcta, presentada de la
              forma correcta.
              <br data-id="element-153" />
              <br data-id="element-154" />
              Más de 1.200 personas ya aplicaron este protocolo. Los resultados
              no son magia: son la consecuencia de entender el problema y atacar
              la causa.
            </p>

            <div className="flex flex-wrap gap-2.5 justify-center md:justify-start" data-id="element-155">
              <span className="bg-gold/10 border border-gold/20 text-gold-light text-[12px] px-3 py-1 rounded-full" data-id="element-156">
                Protocolo de Reprogramación Digestiva™
              </span>
              <span className="bg-gold/10 border border-gold/20 text-gold-light text-[12px] px-3 py-1 rounded-full" data-id="element-157">
                +1.200 casos acompañados
              </span>
              <span className="bg-gold/10 border border-gold/20 text-gold-light text-[12px] px-3 py-1 rounded-full" data-id="element-158">
                Salud digestiva natural
              </span>
              <span className="bg-gold/10 border border-gold/20 text-gold-light text-[12px] px-3 py-1 rounded-full" data-id="element-159">
                Especialista en reflujo crónico
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}